<template>
  <van-tabbar route class="bottomTabbarBar">
    <van-tabbar-item replace to="/index" icon class="iconfont icon-shouye fz12">首页</van-tabbar-item>
    <van-tabbar-item replace to="/activity" icon class="iconfont icon-faxian fz12">活动</van-tabbar-item>
    <van-tabbar-item replace to="/points" icon class="fz12 integralWrap">
      <span>积分兑换</span>
      <template #icon>
        <van-image class="integralImg" :src="integralIcon" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item replace to="/notification" :dot="isNew">
      <span>消息</span>
      <template #icon>
        <i class="iconfont icon-xiaoxi fz12"></i>
      </template>
    </van-tabbar-item>
    <!-- <van-tabbar-item icon="search" class="iconfont iconhudong fz12" dot>标签</van-tabbar-item> -->
    <van-tabbar-item replace to="/user">
      <span>我的</span>
      <template #icon>
        <i class="iconfont icon-wo fz12"></i>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
import { getredpoint } from '@/api/user'
import { getUserId } from '@/libs/util'
export default {
  data() {
    return {
      isNew: false,
      isNewTask: false,
      integralIcon: require('@/assets/images/navBarMiddleIcon.png'),
    }
  },
  created() {
    // this.getNews();
  },
  methods: {
    getNews() {
      getredpoint({ userid: getUserId() }).then((res) => {
        if (res) {
          if (res.message == 0) {
            this.isNew = false
          } else {
            this.isNew = true
          }
        }
      })
    },
  },
}
</script>
<style lang='less'>
.bottomTabbarBar.van-tabbar--fixed {
  bottom: -1px;
}
.bottomTabbarBar {
  z-index: 999;
  background: transparent;
  background-image: url(../../assets/images/navBarBg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 25px;
  .integralImg {
    width: 40px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.bottomTabbarBar.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.bottomTabbarBar .iconfont:before {
  font-size: 18px;
}
.integralWrap {
  .van-tabbar-item__icon {
    margin-top: -25px;
  }
}
</style>